(function () {
  var SELECTOR = '[data-kevilagu-royal-hero]';
  var GSAP_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var SCROLLTRIGGER_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animateSlideIn(slide) {
    if (!slide || !window.gsap || reducedMotion()) return;

    var gsap = window.gsap;
    var media = slide.querySelector('.kevilagu-royal-hero__media');
    var items = slide.querySelectorAll('[data-kl-hero-animate]');

    gsap.killTweensOf(media);
    gsap.killTweensOf(items);

    if (media) {
      gsap.fromTo(media, { scale: 1.12 }, { scale: 1.02, duration: 2.2, ease: 'power2.out' });
    }

    if (items.length) {
      gsap.fromTo(
        items,
        { autoAlpha: 0, y: 30, filter: 'blur(6px)' },
        { autoAlpha: 1, y: 0, filter: 'blur(0px)', duration: 0.95, stagger: 0.1, ease: 'power3.out' }
      );
    }
  }

  function applyParallax(root) {
    if (!window.gsap || !window.ScrollTrigger || reducedMotion()) return;

    var gsap = window.gsap;
    var media = root.querySelectorAll('.kevilagu-royal-hero__media');
    var content = root.querySelectorAll(
      '.kevilagu-royal-hero__slide:not(.kevilagu-royal-hero__slide--framed) .kevilagu-royal-hero__content'
    );

    if (media.length) {
      gsap.to(media, {
        yPercent: 14,
        ease: 'none',
        scrollTrigger: {
          trigger: root,
          start: 'top top',
          end: 'bottom top',
          scrub: 0.6,
        },
      });
    }

    if (content.length) {
      gsap.to(content, {
        yPercent: -14,
        autoAlpha: 0.15,
        ease: 'none',
        scrollTrigger: {
          trigger: root,
          start: 'top top',
          end: 'bottom top',
          scrub: 0.6,
        },
      });
    }
  }

  function initCarousel(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-kl-hero-slide]'));
    if (!slides.length) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kl-hero-dot]'));
    var prevBtn = root.querySelector('[data-kl-hero-prev]');
    var nextBtn = root.querySelector('[data-kl-hero-next]');
    var track = root.querySelector('[data-kl-hero-track]');

    var index = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (index < 0) index = 0;

    var timer = null;
    var autoplay = root.dataset.autoplay === 'true' && slides.length > 1;
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;

    function goTo(nextIndex) {
      var newIndex = (nextIndex + slides.length) % slides.length;
      if (newIndex === index) return;

      slides[index].classList.remove('is-active');
      slides[index].setAttribute('aria-hidden', 'true');
      slides[newIndex].classList.add('is-active');
      slides[newIndex].removeAttribute('aria-hidden');

      dots.forEach(function (dot, i) {
        var active = i === newIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      index = newIndex;
      animateSlideIn(slides[index]);
    }

    function next() {
      goTo(index + 1);
    }

    function prev() {
      goTo(index - 1);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      if (!autoplay || reducedMotion()) return;
      stopAutoplay();
      timer = window.setInterval(next, speed);
    }

    if (slides.length > 1) {
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          next();
          startAutoplay();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prev();
          startAutoplay();
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
          startAutoplay();
        });
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      var touchStartX = null;

      if (track) {
        track.addEventListener(
          'touchstart',
          function (event) {
            touchStartX = event.touches[0].clientX;
            stopAutoplay();
          },
          { passive: true }
        );

        track.addEventListener('touchend', function (event) {
          if (touchStartX === null) return;

          var delta = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(delta) > 40) {
            if (delta < 0) {
              next();
            } else {
              prev();
            }
          }

          touchStartX = null;
          startAutoplay();
        });
      }

      startAutoplay();
    }

    animateSlideIn(slides[index]);
  }

  function init(root) {
    if (!root || root.dataset.klHeroReady === 'true') return;
    root.dataset.klHeroReady = 'true';
    initCarousel(root);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  function loadScript(src, marker) {
    return new Promise(function (resolve) {
      var existing = document.querySelector('script[data-' + marker + ']');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
        } else {
          existing.addEventListener('load', resolve, { once: true });
        }
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.dataset[marker] = 'true';
      script.addEventListener(
        'load',
        function () {
          script.dataset.loaded = 'true';
          resolve();
        },
        { once: true }
      );
      document.head.appendChild(script);
    });
  }

  function loadGsap(callback) {
    if (window.gsap && window.ScrollTrigger) {
      callback();
      return;
    }

    var gsapReady = window.gsap ? Promise.resolve() : loadScript(GSAP_SRC, 'kevilaguGsap');

    gsapReady
      .then(function () {
        return window.ScrollTrigger ? Promise.resolve() : loadScript(SCROLLTRIGGER_SRC, 'kevilaguScrollTrigger');
      })
      .then(function () {
        if (window.gsap && window.ScrollTrigger) {
          window.gsap.registerPlugin(window.ScrollTrigger);
        }
        callback();
      });
  }

  function enhance(root) {
    loadGsap(function () {
      var activeSlide = root.querySelector('.kevilagu-royal-hero__slide.is-active');
      animateSlideIn(activeSlide);
      applyParallax(root);
    });
  }

  function boot() {
    initAll();
    document.querySelectorAll(SELECTOR).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector(SELECTOR) : null;
    if (root) {
      init(root);
      enhance(root);
    }
  });
})();
